import { render } from "./Category.vue?vue&type=template&id=3d535412&scoped=true&bindings={\"goHome\":\"setup\",\"selectMenu\":\"setup\",\"selectProduct\":\"setup\",\"searchWrap\":\"setup\"}"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"

import "./Category.vue?vue&type=style&index=0&id=3d535412&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3d535412"

export default script